(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditWebinarTypeModalCtrl", ["$scope", "learningItemWebinarResource", "learningItemWebinar", "messageService", learningItemEditWebinarTypeModalCtrl]);
    function learningItemEditWebinarTypeModalCtrl($scope, learningItemWebinarResource, learningItemWebinar, messageService) {
        var vm = this;
        vm.learningItemWebinar = learningItemWebinar;
        vm.saveType = function () {
            learningItemWebinarResource.editWebinarType({ learningItemId: vm.learningItemWebinar.learningItemId }, learningItemWebinar, function (result) {
                if (result.value) {
                    messageService.success("learningItem.updatedSuccessMessage");
                    $scope.$close(learningItemWebinar.webinarTypeId);
                }
                else {
                    messageService.error("common.genericError");
                }
            }, function (error) {
                messageService.error(error);
            });
        };
    }
})();
